{
  "title": "Asteroid Atlas",
  "loading": {
     "overpressure_zone": "Druckwelle (0.5 kPa / 0.07 psi)",
    "wind_zone": "Windstoß (10 m/s / 22 mph)", "progress": "Erde wird geladen..."
  },
  "navigation": {
    "title": "Zu Koordinaten navigieren",
    "latitude": "Lat:",
    "longitude": "Lon:",
    "latitude_placeholder": "Breitengrad",
    "longitude_placeholder": "Längengrad",
    "go_to_location": "Zu Standort gehen",
    "add_marker": "Markierung hinzufügen",
    "my_location": "📍 Mein Standort",
    "quick_locations": "Schnelle Standorte:",
    "click_instruction": "Klicken Sie auf die Erde, um Koordinaten an diesem Punkt zu erhalten"
  },
  "locations": {
    "london": "London",
    "tokyo": "Tokio",
    "washington": "Washington",
    "new_york": "New York",
    "paris": "Paris",
    "rio_de_janeiro": "Rio de Janeiro",
    "cairo": "Kairo",
    "mumbai": "Mumbai",
    "moscow": "Moskau",
    "cape_town": "Kapstadt",
    "beijing": "Peking",
    "los_angeles": "Los Angeles",
    "dubai": "Dubai",
    "singapore": "Singapur",
    "reykjavik": "Reykjavik",
    "greenwich": "Greenwich (0°,0°)",
    "null_island": "Null-Insel (0°,0°)"
  },
  "countries": {
    "united_states": "Vereinigte Staaten",
    "united_kingdom": "Vereinigtes Königreich",
    "japan": "Japan",
    "australia": "Australien",
    "france": "Frankreich",
    "brazil": "Brasilien",
    "egypt": "Ägypten",
    "india": "Indien",
    "russia": "Russland",
    "south_africa": "Südafrika",
    "china": "China",
    "united_arab_emirates": "Vereinigte Arabische Emirate",
    "singapore": "Singapur",
    "iceland": "Island"
  },
  "coordinates": {
    "format": "{{lat}}°, {{lon}}°",
    "clicked": "Geklickte Koordinaten: {{lat}}, {{lon}}",
    "your_location": "Ihr Standort: {{lat}}, {{lon}} (±{{accuracy}}m)",
    "found_location": "Standort gefunden!\\nKoordinaten: {{lat}}°, {{lon}}°",
    "found_location_region": "Standort in {{region}} gefunden!\\nKoordinaten: {{lat}}°, {{lon}}°"
  },
  "errors": {
    "geolocation_not_supported": "Geolokalisierung wird von diesem Browser nicht unterstützt.",
    "location_permission_denied": "Standortzugriff vom Benutzer verweigert.",
    "location_unavailable": "Standortinformationen sind nicht verfügbar.",
    "location_timeout": "Standortanfrage ist abgelaufen.",
    "location_unknown": "Ein unbekannter Fehler ist beim Abrufen des Standorts aufgetreten.",
    "invalid_coordinates": "Bitte geben Sie gültige Breiten- und Längengradwerte ein",
    "location_lookup_failed": "Standortsuche fehlgeschlagen"
  },
  "ui": {
    "language": "Sprache",
    "select_language": "Sprache auswählen",
    "impact_zones": "Aufprallzonen",
    "impact_energy": "Aufprallenergie",
    "crater_zone": "Krater (100% Zerstörung)",
    "fireball_zone": "Feuerball (50% Sterblichkeit)",
    "overpressure_zone": "Druckwelle (0.2 kPa / 0.03 psi)",
    "wind_zone": "Windstoß (5 m/s / 11 mph)",
    "seismic_zone": "Seismisch (Meff 7.0)",
    "impact_location": "Aufprallort"
  },
  "info": {
    "asteroid_info": "Asteroidinformationen",
    "earth_info": "Erdinformationen",
    "loading_data": "Daten werden geladen..."
  }
}